import { Box, HStack, Stack, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";

export default function RadioCardGroup({ options, handleChange }) {
  const [selected, setSelected] = React.useState("");
  const handleClick = (itemName) => {
    setSelected((prevState) => itemName);
    handleChange(itemName);
  };
  return (
    <SimpleGrid columns={{ base: 1, md: 3 }} gap={2}>
      {options.map((item,index) => {
        return (
          <Stack
            p={5}
            w="90%"
            key={index}
            border="1px solid #c5c5c5"
            rounded="lg"
            onClick={() => {
              handleClick(item.heading);
            }}
          >
            <HStack w="full" justifyContent="space-between">
              <Box color="#727272" fontSize="24px">
                {item.icon}
              </Box>
              <Box p={"2px"} border="1px solid #c5c5c5" rounded="full">
                <Box
                  p={2}
                  bg={selected === item.heading && "brand.500"}
                  rounded="full"
                />
              </Box>
            </HStack>
            <Text
              align="start"
              fontWeight="semibold"
              color="#727272"
              fontSize={{ base: "16px", md: "18px" }}
            >
              {item.heading}
            </Text>
            <Text
              align="start"
              color="#c5c5c5"
              fontSize={{ base: "12px", md: "14px" }}
              fontWeight="medium"
            >
              {item.text}
            </Text>
          </Stack>
        );
      })}
    </SimpleGrid>
  );
}
